<template>
  <div class="annual">
    <HearderTitle name="年度分析" />
    <div class="annual_main">
      <div class="annual-analysis-con">
        <highcharts style="height: 320px" :options="chartOptions1"></highcharts>
      </div>
      <div class="annual-analysis-con">
        <highcharts style="height: 320px" :options="chartOptions2"></highcharts>
      </div>
      <div class="annual-analysis-con">
        <highcharts style="height: 320px" :options="chartOptions3"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
  import HearderTitle from '@/components/HearderTitle'
  import { annualAnalysis } from '@/api/personnelList'
  import { Chart } from 'highcharts-vue'
  export default {
    name: 'annualAnalysis',
    data() {
      return {
        chartOptions1: {
          chart: {
            type: 'column',
          },

          title: {
            text: '近一年在职人数',
          },

          xAxis: {
            categories: [],
            crosshair: true,
          },

          yAxis: {
            min: 0,
            title: {
              text: '数量',
            },
          },

          tooltip: {
            headerFormat: '<span style="font-size:12px">时间：{point.key}</span><br/>',
            pointFormat: '<span style="font-size:12px">人数：{point.y}</span>',
            shared: true,
            useHTML: true,
          },

          plotOptions: {
            column: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                verticalAlign: 'top', // 竖直对齐方式，默认是 center
                inside: true,
              },
            },
          },

          series: [{}],
          credits: {
            enabled: false,
          },
        },
        chartOptions2: {
          chart: {
            type: 'column',
          },

          title: {
            text: '近一年入职趋势',
          },

          xAxis: {
            categories: [],
            crosshair: true,
          },

          yAxis: {
            min: 0,
            title: {
              text: '数量',
            },
          },

          tooltip: {
            headerFormat: '<span style="font-size:12px">时间：{point.key}</span><br/>',
            pointFormat: '<span style="font-size:12px">人数：{point.y}</span>',
            shared: true,
            useHTML: true,
          },

          plotOptions: {
            column: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                verticalAlign: 'top', // 竖直对齐方式，默认是 center
                inside: true,
              },
            },
          },

          series: [{}],
          credits: {
            enabled: false,
          },
        },
        chartOptions3: {
          chart: {
            type: 'column',
          },

          title: {
            text: '近一年离职趋势',
          },

          xAxis: {
            categories: [],
            crosshair: true,
          },

          yAxis: {
            min: 0,
            title: {
              text: '数量',
            },
          },

          tooltip: {
            headerFormat: '<span style="font-size:12px">时间：{point.key}</span><br/>',
            pointFormat: '<span style="font-size:12px">人数：{point.y}</span>',
            shared: true,
            useHTML: true,
          },

          plotOptions: {
            column: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                verticalAlign: 'top', // 竖直对齐方式，默认是 center
                inside: true,
              },
            },
          },

          series: [{}],
          credits: {
            enabled: false,
          },
        },
      }
    },
    created() {
      this.getAnnualAnalysisList()
    },
    methods: {
      async getAnnualAnalysisList() {
        let res = await annualAnalysis()
        this.chartOptions1.xAxis.categories = res.data.zzgv.x
        this.chartOptions1.series = [res.data.zzgv.v]
        this.chartOptions2.xAxis.categories = res.data.rzgv.x
        this.chartOptions2.series = [res.data.rzgv.v]
        this.chartOptions3.xAxis.categories = res.data.lzgv.x
        this.chartOptions3.series = [res.data.lzgv.v]
      },
    },
    components: { HearderTitle, highcharts: Chart },
  }
</script>

<style lang="less" scoped>
  .annual_main {
    padding-top: 28px;
  }
  .annual-analysis-con {
    height: 320px;
    margin-bottom: 20px;
    outline: solid 1px #e6e6e6;
    .highcharts-container {
      height: 320px !important;
    }
  }
</style>
